<mat-sidenav-container class="h-screen">
  <!-- Sidebar -->
  <mat-sidenav mode="side" opened
    class="bg-gray-900 text-white w-64 md:w-56 sm:w-52 h-full flex flex-col justify-between"
    [mode]="(isMobile ? 'over' : 'side')" [opened]="!isMobile">
    <div class="flex justify-center items-center p-4 bg-white">
      <img src="assets/puma-logo.png" alt="PUMA Logo" class="w-48 sm:w-40" />
    </div>

    <span class="text-base flex items-center justify-center text-black pr-3 qqmeTxt_2">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="pr-3">
        <path
          d="M6.54 5C6.6 5.89 6.75 6.76 6.99 7.59L5.79 8.79C5.38 7.59 5.12 6.32 5.03 5H6.54ZM16.4 17.02C17.25 17.26 18.12 17.41 19 17.47V18.96C17.68 18.87 16.41 18.61 15.2 18.21L16.4 17.02ZM7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.51C21 15.96 20.55 15.51 20 15.51C18.76 15.51 17.55 15.31 16.43 14.94C16.33 14.9 16.22 14.89 16.12 14.89C15.86 14.89 15.61 14.99 15.41 15.18L13.21 17.38C10.38 15.93 8.06 13.62 6.62 10.79L8.82 8.59C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3Z"
          fill="var(--app-heading)" />
      </svg> 213.947.0000
    </span>
  </mat-sidenav>

  <mat-sidenav-content style="background-color: var(--app-canvas)">
    <mat-toolbar style="background-color: var(--app-surface-subtle)" class="flex justify-center items-center h-32">
      <div class="flex flex-col text-center">
        <h2 class="title m-0 font-medium text-2xl">Appointment Request Form</h2>
        <p class="m-0 demo_text">Our team will reach out to you after form submission.</p>
        <p class=" m-0  demo_text_2">Required fields are marked with an asterisk*</p>
      </div>
    </mat-toolbar>

    <div *ngIf="!isRecaptchaVerified" class="flex justify-center items-center">
      <div class="flex-col flex gap-2 justify-center items-center h-full my-3">
        <h2 class="title m-0 font-medium text-xl py-4">Complete the CAPTCHA to proceed</h2>
        <re-captcha (resolved)="onRecaptchaResolved($event)"
          siteKey="6LdmgpIqAAAAAOA0iZF5FC9cz1FbNYyr8-3sN3EY"></re-captcha>
      </div>

    </div>


    <div *ngIf="isRecaptchaVerified">

      <mat-spinner [diameter]="40" class="qqmeBtn" *ngIf="isLoading"></mat-spinner>

      <div @fadeInUp [@stagger]="true" class="p-gutter h-full min-h-screen vexContainer overflow-y-auto bg-[var(--app-canvas)]"
        *ngIf="!isLoading">
        <div class="card h-auto min-h-full">
          <div class="px-24 py-6" fxLayout="column">

            <form [formGroup]="form" (keydown.enter)="$event.preventDefault()">
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Organization</mat-label>
            <mat-select formControlName="organizationId" (selectionChange)="onOrganizationChange()" required>
              <mat-option *ngFor="let organization of organizations" [value]="organization._id">{{ organization.name }}</mat-option>
            </mat-select>
            <mat-error>Organization is required.</mat-error>
          </mat-form-field>
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px" class="mt-2">
                <h2 class="title m-0 qqmeTxt_2">Requesting party details</h2>
                <!-- <span fxFlex></span> -->
                <!-- <mat-checkbox formControlName="sibtf">SIBTF</mat-checkbox> -->
              </div>
              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0" class="mt-2">
                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label> Name</mat-label>
                  <input matInput type="text" formControlName="reqFirstName"
                    (input)="capitalizeFirstLetter('reqFirstName')" (paste)="capitalizeFirstLetter('reqFirstName')"
                    required />
                  <mat-error *ngIf="form.get('reqFirstName').hasError('required')">
                    Name is required .
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label> Middle Name</mat-label>
                  <input matInput type="text" formControlName="reqMiddleName"
                    (input)="capitalizeFirstLetter('reqMiddleName')" (paste)="capitalizeFirstLetter('reqMiddleName')" />
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label> Last Name</mat-label>
                  <input matInput type="text" formControlName="reqLastName"
                    (input)="capitalizeFirstLetter('reqLastName')" (paste)="capitalizeFirstLetter('reqLastName')"
                    required />
                  <mat-error *ngIf="form.get('reqLastName').hasError('required')">
                    Last Name is required.
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>Email</mat-label>
                  <input matInput type="text" formControlName="reqEmail" required />
                  <mat-error *ngIf="form.get('reqEmail').hasError('required')">
                    Email is required.
                  </mat-error>
                  <mat-error *ngIf="form.get('reqEmail').hasError('email')">
                    Please enter a valid email address.
                  </mat-error>
                </mat-form-field>


                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>Requesting Party</mat-label>
                  <mat-select formControlName="reqParty" required>
                    <mat-option *ngFor="let party of requestingParties" [value]="party">
                      {{ party }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="form.get('reqParty').hasError('required')">
                    Is required.
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px" class="mt-4">
                <h2 class="title m-0">Applicant details</h2>
              </div>


              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0" class="mt-3">
                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>First name</mat-label>
                  <input matInput type="text" (input)="capitalizeFirstLetter('applicantName')"
                    (paste)="capitalizeFirstLetter('applicantName')" formControlName="applicantName" />

                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>Middle name</mat-label>
                  <input matInput type="text" formControlName="applicantMiddleName"
                    (input)="capitalizeFirstLetter('applicantMiddleName')"
                    (paste)="capitalizeFirstLetter('applicantMiddleName')" />
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>Last name</mat-label>
                  <input matInput type="text" formControlName="applicantLastName"
                    (input)="capitalizeFirstLetter('applicantLastName')"
                    (paste)="capitalizeFirstLetter('applicantLastName')" />

                </mat-form-field>
              </div>

              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>Date of birth</mat-label>
                  <input matInput [matDatepicker]="picker" formControlName="dob" [max]="maxDate" />
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  <!-- <mat-error *ngIf="form.get('dob').hasError('required')">
                    Date of birth is required.
                  </mat-error> -->
                </mat-form-field>


                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>Gender</mat-label>
                  <mat-select formControlName="gender">
                    <mat-option value="Male">Male</mat-option>
                    <mat-option value="Female">Female</mat-option>
                  </mat-select>
                  <!-- <mat-error *ngIf="form.get('gender').hasError('required')">
                    Gender is required.
                  </mat-error> -->
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>SSN</mat-label>
                  <input matInput type="text" formControlName="ssn" appSSNFormatter maxlength="11" />
                  <mat-error *ngIf="form.get('ssn').hasError('invalidSSN')">
                    SSN must be in the format XXX-XX-XXXX.
                  </mat-error>
                </mat-form-field>

              </div>


              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>Address line 1</mat-label>
                  <input matInput type="text" formControlName="address" />

                </mat-form-field>
                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>Address line 2</mat-label>
                  <input matInput type="text" formControlName="address_2" />
                </mat-form-field>
              </div>

              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>City</mat-label>
                  <input matInput type="text" formControlName="city" />


                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>State</mat-label>
                  <mat-select formControlName="state">
                    <mat-option *ngFor="let state of states" [value]="state">{{
                      state
                      }}</mat-option>
                  </mat-select>

                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>Zip</mat-label>
                  <input matInput type="text" formControlName="zip" maxlength="9" />

                </mat-form-field>
              </div>

              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">


                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>Home Phone</mat-label>

                  <ng-container *ngIf="!isPhoneInput; else phoneInputTemplate">
                    <mat-select formControlName="phone" (selectionChange)="onPhoneSelectionChange($event.value)">
                      <mat-option [value]="'None Provided'">None Provided</mat-option>
                      <mat-option [value]="'Enter Phone'">Enter Phone</mat-option>
                    </mat-select>
                  </ng-container>

                  <ng-template #phoneInputTemplate>
                    <div style="display: flex; align-items: center; gap: 4px; width: 100%;">
                      <input matInput type="text" formControlName="phone" appPhoneFormatter maxlength="14"
                        placeholder="Enter Phone Number" style="flex: 1; min-width: 0;" />

                      <!-- <button mat-icon-button class="text-gray -mt-8 " (click)="onPhoneSelectionChange('None Provided')"
                        matTooltip="Reset to None Provided"
                        style="height: 20px; width: 20px; min-width: 20px; padding: 0;"> -->
                        <mat-icon class="text-gray -mt-1 " (click)="onPhoneSelectionChange('None Provided')"
                        matTooltip="Reset to None Provided" style="font-size: 20px;">close</mat-icon>
                      <!-- </button> -->
                    </div>


                  </ng-template>

                  <!-- <mat-error *ngIf="form.get('phone')?.hasError('required')">
                    Home phone is required
                  </mat-error> -->
                  <mat-error *ngIf="form.get('phone')?.hasError('invalidPhone')">
                    Invalid phone number format. Use (XXX) XXX-XXXX.
                  </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>Cell phone</mat-label>

                  <mat-select *ngIf="!isCellPhoneInput" formControlName="altPhone"
                    (selectionChange)="onAltPhoneSelectionChange($event.value)">
                    <mat-option [value]="'None Provided'">None Provided</mat-option>
                    <mat-option [value]="'Enter Phone'">Enter Phone</mat-option>
                  </mat-select>

                  <div *ngIf="isCellPhoneInput" style="display: flex; align-items: center; gap: 4px; width: 100%;">
                    <input matInput type="text" formControlName="altPhone" appPhoneFormatter maxlength="14"
                      placeholder="Enter Phone Number" style="flex: 1; min-width: 0;" />
                    <!-- <button mat-icon-button class="text-gray -mt-8 "
                      (click)="onAltPhoneSelectionChange('None Provided')" matTooltip="Reset to None Provided"
                      style="height: 20px; width: 20px; min-width: 20px; padding: 0;"> -->
                      <mat-icon class="text-gray -mt-1"
                      (click)="onAltPhoneSelectionChange('None Provided')" matTooltip="Reset to None Provided" style="font-size: 20px;">close</mat-icon>
                    <!-- </button> -->
                  </div>

                  <mat-error *ngIf="form.get('altPhone')?.hasError('invalidPhone')">
                    Invalid phone number format. Use (XXX) XXX-XXXX.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>Work phone</mat-label>

                  <mat-select *ngIf="!isWorkPhoneInput" formControlName="workPhone"
                    (selectionChange)="onWorkPhoneSelectionChange($event.value)">
                    <mat-option [value]="'None Provided'">None Provided</mat-option>
                    <mat-option [value]="'Enter Phone'">Enter Phone</mat-option>
                  </mat-select>

                  <div *ngIf="isWorkPhoneInput" style="display: flex; align-items: center; gap: 4px; width: 100%;">
                    <input matInput type="text" formControlName="workPhone" appPhoneFormatter maxlength="14"
                      placeholder="Enter Phone Number" style="flex: 1; min-width: 0;" />
                    <!-- <button mat-icon-button class="text-gray -mt-8 "
                      (click)="onWorkPhoneSelectionChange('None Provided')" matTooltip="Reset to None Provided"
                      style="height: 20px; width: 20px; min-width: 20px; padding: 0;"> -->
                      <mat-icon class="text-gray -mt-1 "
                      (click)="onWorkPhoneSelectionChange('None Provided')" matTooltip="Reset to None Provided" style="font-size: 20px;">close</mat-icon>
                    <!-- </button> -->
                  </div>

                  <mat-error *ngIf="form.get('workPhone')?.hasError('invalidPhone')">
                    Invalid phone number format. Use (XXX) XXX-XXXX.
                  </mat-error>
                </mat-form-field>

              </div>
              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>Email</mat-label>
                  <input matInput type="text" formControlName="email" />
                  <mat-error *ngIf="form.get('email').hasError('email')">
                    Please enter a valid email address.
                  </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>Job title</mat-label>
                  <input matInput type="text" formControlName="jobtitle" />

                </mat-form-field>

              </div>


              <h2 class="title m-0 text-black font-medium mt-6">
                Injury details <mat-checkbox class="px-4" formControlName="sibtf">SIBTF</mat-checkbox>
              </h2>


              <div formArrayName="injuryDetails" *ngIf="form.get('sibtf')?.value !== true">
                <div *ngFor="let detail of injuryDetails.controls; let i = index">
                  <div [formGroupName]="i">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px">
                      <!-- {{ i + 1 }} removed as suggested -->

                    </div>

                    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0" class="mt-6">
                      <div fxFlex="auto">
                        <mat-radio-group formControlName="injuryType" (change)="onInjuryTypeChange(i)">
                          <mat-radio-button value="specific" class="px-4">Specific</mat-radio-button>
                          <mat-radio-button value="cumulative">Cumulative</mat-radio-button>
                        </mat-radio-group>
                      </div>
                    </div>

                    <ng-container *ngIf="detail.get('injuryType')?.value === 'specific'">

                      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0" class="mt-6">
                        <mat-form-field appearance="outline" fxFlex="auto">
                          <mat-label>Date of injury</mat-label>
                          <input matInput [matDatepicker]="picker" formControlName="specificDate" [max]="maxDate" />
                          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                        <div fxFlex="auto"></div>
                        <div fxFlex="auto"></div>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="detail.get('injuryType')?.value === 'cumulative'">
                      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0" class="mt-6">
                        <mat-form-field appearance="outline" fxFlex="auto">
                          <mat-label>Date Range of Injury</mat-label>
                          <mat-date-range-input [formGroup]="detail" [rangePicker]="dateRangePicker" [max]="maxDate">
                            <input matStartDate placeholder="Start date" formControlName="start" />
                            <input matEndDate placeholder="End date" formControlName="end" />
                          </mat-date-range-input>
                          <mat-datepicker-toggle matSuffix [for]="dateRangePicker"></mat-datepicker-toggle>
                          <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
                        </mat-form-field>
                        <div fxFlex="auto"></div>
                        <div fxFlex="auto"></div>
                      </div>
                    </ng-container>

                    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                      <mat-form-field appearance="outline" fxFlex="auto">
                        <mat-label>Injured body parts</mat-label>
                        <mat-chip-list #chipList>
                          <mat-chip *ngFor="
                                let part of detail.get('injuryBodyPart').value || []
                              " [removable]="true" (removed)="removeChip(i, part)">
                            {{ part }}
                            <mat-icon matChipRemove (click)="$event.stopPropagation()">cancel</mat-icon>
                          </mat-chip>
                        </mat-chip-list>
                        <input matInput readonly tabindex="-1" style="cursor: pointer;" />

                      </mat-form-field>
                    </div>

                    <div class="mt-3" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                      <ng-container *ngIf="
                            !injuryDetails.at(i).get('isCustomWCAB').value;
                            else customWCABInput
                          ">
                        <mat-form-field appearance="outline" fxFlex="auto">
                          <mat-label>WCAB Case Number</mat-label>
                          <mat-select formControlName="WCAB" (selectionChange)="onWCABChange(i, $event.value)">
                            <mat-option [value]="'None Provided'">None Provided</mat-option>
                            <mat-option [value]="''">Enter Custom Text</mat-option>
                          </mat-select>

                        </mat-form-field>
                      </ng-container>

                      <ng-template #customWCABInput>
                        <mat-form-field appearance="outline" fxFlex="auto">
                          <mat-label>WCAB Case Number</mat-label>
                          <input matInput formControlName="WCAB" (keypress)="restrictNonAlphanumeric($event)" />
                        </mat-form-field>
                      </ng-template>

                      <ng-container *ngIf="
                            !injuryDetails.at(i).get('isCustomClaimNumber').value;
                            else customClaimNumberInput
                          ">
                        <mat-form-field appearance="outline" fxFlex="auto">
                          <mat-label>Claim Number</mat-label>
                          <mat-select formControlName="claimNumber"
                            (selectionChange)="onClaimNumberChange(i, $event.value)">
                            <mat-option [value]="'None Provided'">None Provided</mat-option>
                            <mat-option [value]="''">Enter Custom Text</mat-option>
                          </mat-select>

                        </mat-form-field>
                      </ng-container>

                      <ng-template #customClaimNumberInput>
                        <mat-form-field appearance="outline" fxFlex="auto">
                          <mat-label> Claim Number</mat-label>
                          <input matInput formControlName="claimNumber" />
                        </mat-form-field>
                      </ng-template>


                      <button mat-icon-button type="button" matTooltip="Remove" class="qqmeIcon-2"
                        (click)="removeInjuryDetail(i)">
                        <mat-icon>remove_circle</mat-icon>
                      </button>
                    </div>
                    <div class="mb-3" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="1px" fxLayoutGap.lt-md="0">
                      <mat-hint align="start" class="text-black">If no data has been provided for WCAB case number or
                        claim
                        number, select ‘None provided’ from the menu.</mat-hint>
                    </div>

                  </div>
                </div>

                <button mat-button type="button" matTooltip="Add Injury" class="qqmeIcon-2 mt-1"
                  (click)="addInjuryDetail()">
                  + Add Injury
                </button>
              </div>

              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px" class="mt-10">
                <h2 class="title m-0">Encounter details</h2>
              </div>

              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0" class="mt-6">
                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>Physician</mat-label>
                  <mat-select formControlName="physician" (selectionChange)="onPhysicianChange($event.value)">
                    <mat-option *ngFor="let physician of physicians" [value]="physician._id">
                      {{ physician.displayName }}
                    </mat-option>
                  </mat-select>

                </mat-form-field>
              </div>
              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>Medical Evaluation Type</mat-label>
                  <mat-select formControlName="medicalEvaluationType">
                    <mat-option value="Qualified Medical Evaluation">Qualified Medical Evaluation</mat-option>
                    <mat-option value="Agreed Medical Evaluation">Agreed Medical Evaluation</mat-option>
                  </mat-select>

                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="auto"
                  *ngIf="form.get('medicalEvaluationType')?.value === 'Qualified Medical Evaluation'">
                  <mat-label>Encounter type</mat-label>
                  <mat-select formControlName="encounterType">
                    <mat-option value="PQME">PQME</mat-option>
                    <mat-option value="PQMER">PQMER</mat-option>
                    <mat-option value="PQMES">PQMES</mat-option>
                    <mat-option value="PQMED">PQMED</mat-option>
                    <mat-option value="Reflex PQMES">Reflex PQMES</mat-option>
                    <mat-option value="SIBTF">SIBTF</mat-option>
                  </mat-select>

                </mat-form-field>

                <mat-form-field *ngIf="form.get('medicalEvaluationType')?.value === 'Agreed Medical Evaluation'"
                  appearance="outline" fxFlex="auto">
                  <mat-label>Encounter type</mat-label>
                  <mat-select formControlName="encounterType">
                    <mat-option value="AME">AME</mat-option>
                    <mat-option value="AMER">AMER</mat-option>
                    <mat-option value="AMES">AMES</mat-option>
                    <mat-option value="AMED">AMED</mat-option>
                    <mat-option value="Reflex AMES">Reflex AMES</mat-option>
                  </mat-select>

                </mat-form-field>


                <mat-form-field appearance="outline" fxFlex="auto" *ngIf="
                  form.get('medicalEvaluationType')?.value !==
                  'Agreed Medical Evaluation' && form.get('sibtf')?.value !== true
                ">
                  <mat-label>Panel Number</mat-label>
                  <input matInput formControlName="panelNumber" (keypress)="restrictNonNumeric($event)"
                    (paste)="restrictNonNumeric($event)" />
                  <!-- <mat-error *ngIf="form.get('panelNumber').hasError('required')">
                  panel number is required.
                </mat-error> -->
                </mat-form-field>




              </div>
              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>Date Range</mat-label>
                  <mat-date-range-input [rangePicker]="dateRangePicker1">
                    <input matStartDate placeholder="Start date" formControlName="reqDateRange_start" />
                    <input matEndDate placeholder="End date" formControlName="reqDateRange_end" />
                  </mat-date-range-input>
                  <mat-datepicker-toggle matSuffix [for]="dateRangePicker1"></mat-datepicker-toggle>
                  <mat-date-range-picker #dateRangePicker1></mat-date-range-picker>

                  <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                </mat-form-field>
                <div fxFlex="auto"></div>
                <div fxFlex="auto"></div>
              </div>


              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0" *ngIf="
              form.get('encounterType')?.value !== 'PQMES' &&
              form.get('encounterType')?.value !== 'AMES' &&
              form.get('encounterType')?.value !== 'Reflex AMES' &&
              form.get('encounterType')?.value !== 'Reflex PQMES' 
                ">
                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>Examination address</mat-label>
                  <mat-select formControlName="examinationAddress">
                    <mat-option *ngFor="let clinic of clinics" [value]="clinic.locationId._id">
                      {{ clinic.locationId.office | titlecase }} -
                      {{ clinic.locationId.clinic_address | titlecase }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0" *ngIf="
              form.get('encounterType')?.value !== 'PQMES' &&
              form.get('encounterType')?.value !== 'AMES' &&
              form.get('encounterType')?.value !== 'Reflex AMES' &&
              form.get('encounterType')?.value !== 'Reflex PQMES' 
                ">
                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>City</mat-label>
                  <input matInput type="text" formControlName="examinationCity"
                    (input)="capitalizeFirstLetter('examinationCity')"
                    (paste)="capitalizeFirstLetter('examinationCity')" />

                  <!-- <mat-error *ngIf="
                        form.get('examinationCity').hasError('required') ||
                        form.get('examinationCity').hasError('whitespace')
                      ">
                      City is required.
                    </mat-error> -->
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>State</mat-label>
                  <mat-select formControlName="examinationState">
                    <mat-option *ngFor="let state of states" [value]="state">{{
                      state
                      }}</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>Zip</mat-label>
                  <input matInput type="text" formControlName="examinationZip" maxlength="9" />

                </mat-form-field>
              </div>

              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0" *ngIf="
                form.get('encounterType')?.value !== 'PQMED' &&
                form.get('encounterType')?.value !== 'AMED' &&
                form.get('encounterType')?.value !== 'PQMES' &&
                form.get('encounterType')?.value !== 'AMES' &&
                form.get('encounterType')?.value !== 'Reflex AMES' &&
                form.get('encounterType')?.value !== 'Reflex PQMES' &&
                form.get('encounterType')?.value !== 'SIBTF'
              ">
                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>Evaluation type</mat-label>
                  <input
                    matInput
                    formControlName="evaluationType"
                    [readonly]="true"
                    [value]="form.get('evaluationType')?.value || ''"
                  />
                </mat-form-field>
                <div fxFlex="auto" *ngIf="previousEncounterLength === 0">
                  <mat-checkbox formControlName="check_previousEncounter" class="mat-checkbox-label">
                    No previous evaluations
                  </mat-checkbox>
                </div>
                <div fxFlex="auto"></div>
                <div fxFlex="auto"></div>
              </div>

              <div formArrayName="previousEncounter">
                <div *ngFor="let detail of previousEncounter.controls; let i = index">
                  <div [formGroupName]="i" class="mt-2">
                    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                      <mat-form-field appearance="outline" fxFlex="auto">
                        <mat-label>Previous evaluation date</mat-label>
                        <input matInput [matDatepicker]="previousDate" formControlName="previousDate" />
                        <mat-datepicker-toggle matSuffix [for]="previousDate"></mat-datepicker-toggle>
                        <mat-datepicker #previousDate></mat-datepicker>
                      </mat-form-field>

                      <mat-form-field appearance="outline" fxFlex="auto">
                        <mat-label> Previous evaluation type</mat-label>
                        <mat-select formControlName="evaluationType">
                          <mat-option value="Basic">Basic</mat-option>
                          <mat-option value="Comprehensive">Comprehensive</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <div fxFlex="auto"></div>
                      <div fxFlex="auto"></div>

                      <button mat-icon-button fxFlex="auto" type="button" matTooltip="Remove" class="qqmeIcon-2"
                        (click)="removePreviousDetail(i)">
                        <mat-icon>remove_circle</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>

                <button mat-button type="button" matTooltip="Add Previous Encounter" class="qqmeIcon-2"
                  *ngIf="form.get('check_previousEncounter')?.value == false || previousEncounter.length > 0"
                  (click)="addPreviousDetail()">
                  + Add previous encounter date
                </button>

              </div>

              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0" class="mt-6">
                <h2 class="title m-0 ">Upload documents</h2>
              </div>

              <div *ngIf="
                    form.get('encounterType')?.value !== 'PQMED' &&
                    form.get('encounterType')?.value !== 'AMED'
                  ">
                <div class="mt-4" *ngIf="form.get('sibtf')?.value !== true">

                  <div class="upload-box" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
                    (drop)="onDrop($event, 'strikePanel')" [ngClass]="{'drag-over': isDragOver}">

                    <p class="head m-0">Upload strike panel</p>

                    <p class="sub-head m-0 mt-1">
                      Drop file here or
                      <label class="browse-button">
                        browse
                        <input accept=".pdf, .png, .jpg, .jpeg, .doc, .docx" type="file" #fileInputStrikePanel
                          (change)="onFileSelected($event, 'strikePanel')" hidden />
                      </label>
                    </p>
                    <p class="label m-0">Supports DOC, DOCX, PDF, JPG, JPEG and PNG</p>
                  </div>
                </div>

                <div *ngFor="let file of selectedStrikePanelFiles; let i = index" fxLayout="row"
                  fxLayoutAlign="start center" fxLayoutGap="24px" class="mt-2">
                  <mat-icon>insert_drive_file</mat-icon>
                  <span>{{ file.name }}</span>
                  <button mat-icon-button class="text-gray" (click)="removeFile(i, 'strikePanel')">
                    <mat-icon>clear</mat-icon>
                  </button>
                </div>


                <div class="mt-6">
                  <div class="upload-box" (dragover)="onDragOver_2($event)" (dragleave)="onDragLeave_2($event)"
                    (drop)="onDrop($event, 'attorneyDemo')" [ngClass]="{'drag-over': isDragOver_2}">
                    <p class="head m-0">Upload attorney demos</p>
                    <p class="sub-head m-0 mt-1">
                      Drop file here or
                      <label class="browse-button">
                        browse
                        <input accept=".pdf,.doc,.docx" type="file" #fileInputAttorneyDemos
                          (change)="onFileSelected($event, 'attorneyDemo')" multiple hidden />
                      </label>
                    </p>
                    <p class="label m-0">Supports DOC, DOCX and PDF</p>
                  </div>
                </div>

                <div *ngFor="let file of selectedAttorneyDemoFiles; let i = index" fxLayout="row"
                  fxLayoutAlign="start center" fxLayoutGap="24px" class="mt-2">
                  <mat-icon>insert_drive_file</mat-icon>
                  <span>{{ file.name }}</span>
                  <button mat-icon-button class="text-gray" (click)="removeFile(i, 'attorneyDemo')">
                    <mat-icon>clear</mat-icon>
                  </button>
                </div>

              </div>

              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0" class="mt-10"
              *ngIf="
              form.get('encounterType')?.value !== 'PQMES' &&
              form.get('encounterType')?.value !== 'AMES' &&
              form.get('encounterType')?.value !== 'Reflex AMES' &&
              form.get('encounterType')?.value !== 'Reflex PQMES'
                ">
            
                <h2 class="title m-0 qqmeTxt_2">Interpreter details</h2>
                <mat-checkbox formControlName="interpreter">
                  Interpreter required
                </mat-checkbox>
              </div>

              <div *ngIf="form.get('interpreter').value" class="mt-4">
                <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="24px" fxLayoutGap.lt-sm="0">
                  <!-- <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Language</mat-label>
                    <mat-select formControlName="language">
                      <mat-option *ngFor="let language of languages" [value]="language">
                        {{ language }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field> -->
                                <mat-form-field
                *ngIf="!isCustomLanguage"
                appearance="outline"
                fxFlex="auto"
              >
                <mat-label>Language</mat-label>
                <mat-select
                  formControlName="language"
                  (selectionChange)="onLanguageChange($event.value)"
                >
                  <mat-option
                    *ngFor="let language of languages"
                    [value]="language"
                  >
                    {{ language }}
                  </mat-option>
                  <mat-option value="custom">Other Language</mat-option>
                </mat-select>
              </mat-form-field>

              <!-- Show this only in custom language mode -->
              <mat-form-field
                *ngIf="isCustomLanguage"
                appearance="outline"
                fxFlex="auto"
              >
                <mat-label>Custom Language</mat-label>
                <input
                  matInput
                  [formControl]="customLanguageControl"
                  placeholder="Enter custom language"
                  (input)="updateCustomLanguage()"
                />
              </mat-form-field>

                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Vendor name</mat-label>
                    <input matInput type="text" formControlName="vendor" (input)="capitalizeFirstLetter('vendor')"
                      (paste)="capitalizeFirstLetter('vendor')" />
                    <!-- <mat-hint align="start" style="color: var(--app-accent); font-weight: 500">Optional</mat-hint> -->
                  </mat-form-field>

                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Vendor phone</mat-label>
                    <input matInput type="text" formControlName="vendorPhone" appPhoneFormatter maxlength="14" />
                    <mat-error *ngIf=" form.get('vendorPhone').hasError('invalidPhone')">
                      Invalid phone number format. Use (XXX) XXX-XXXX.
                    </mat-error>
                    <!-- <mat-hint align="start" style="color: var(--app-accent); font-weight: 500">Optional</mat-hint> -->
                  </mat-form-field>
                </div>
              </div>

              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px" class="mt-10">
                <h2 class="title m-0">Applicant attorney details</h2>

                <mat-checkbox formControlName="unrepresented"
                  *ngIf="form.get('sibtf')?.value !== true">Unrepresented</mat-checkbox>
              </div>

              <div *ngIf="!form.get('unrepresented').value">
                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0" class="mt-3">
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Firm</mat-label>
                    <input matInput type="text" formControlName="firm" (input)="capitalizeFirmName('firm')"
                      (paste)="capitalizeFirmName('firm')" />
                  </mat-form-field>
                  <div fxFlex="auto"></div>
                  <div fxFlex="auto"></div>
                </div>
                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0" class="mt-3">
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>First name</mat-label>
                    <input matInput type="text" formControlName="applicantAttorneyname"
                      (input)="capitalizeFirstLetter('applicantAttorneyname')"
                      (paste)="capitalizeFirstLetter('applicantAttorneyname')" />
                  </mat-form-field>
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Middle name</mat-label>
                    <input matInput type="text" formControlName="applicantAttorneymiddle"
                      (input)="capitalizeFirstLetter('applicantAttorneymiddle')"
                      (paste)="capitalizeFirstLetter('applicantAttorneymiddle')" />
                  </mat-form-field>
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Last name</mat-label>
                    <input matInput type="text" formControlName="applicantAttorneylast"
                      (input)="capitalizeFirstLetter('applicantAttorneylast')"
                      (paste)="capitalizeFirstLetter('applicantAttorneylast')" />
                  </mat-form-field>
                </div>

                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Address line 1</mat-label>
                    <input matInput type="text" formControlName="applicantAttorneyaddress" />
                  </mat-form-field>

                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Address line 2</mat-label>
                    <input matInput type="text" formControlName="applicantAttorneyaddress_2" />
                  </mat-form-field>

                </div>

                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>City</mat-label>
                    <input matInput type="text" formControlName="applicantAttorneyCity"
                      (input)="capitalizeFirstLetter('applicantAttorneyCity')"
                      (paste)="capitalizeFirstLetter('applicantAttorneyCity')" />
                  </mat-form-field>

                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>State</mat-label>
                    <mat-select formControlName="applicantAttorneyState">
                      <mat-option *ngFor="let state of states" [value]="state">{{
                        state
                        }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Zip</mat-label>
                    <input matInput type="text" formControlName="applicantAttorneyZip" maxlength="9" />
                  </mat-form-field>
                </div>

                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">


                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Phone</mat-label>

                    <mat-select *ngIf="!applicantAttorneyTelePhoneInput" formControlName="applicantAttorneyTelePhone"
                      (selectionChange)="onAttorneyPhoneSelectionChange($event.value)">
                      <mat-option [value]="'None Provided'">None Provided</mat-option>
                      <mat-option [value]="'Enter Phone'">Enter Phone</mat-option>
                    </mat-select>

                    <div *ngIf="applicantAttorneyTelePhoneInput"
                      style="display: flex; align-items: center; gap: 4px; width: 100%;">
                      <input matInput type="text" formControlName="applicantAttorneyTelePhone" appPhoneFormatter
                        maxlength="14" placeholder="Enter Phone Number" style="flex: 1; min-width: 0;" />
                      <button mat-icon-button class="text-gray -mt-8 "
                        (click)="onAttorneyPhoneSelectionChange('None Provided')" matTooltip="Reset to None Provided"
                        style="height: 20px; width: 20px; min-width: 20px; padding: 0;">
                        <mat-icon style="font-size: 18px;">close</mat-icon>
                      </button>
                    </div>

                    <mat-error *ngIf="form.get('applicantAttorneyTelePhone')?.hasError('invalidPhone')">
                      Invalid phone number format. Use (XXX) XXX-XXXX.
                    </mat-error>
                  </mat-form-field>


                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Fax</mat-label>
                    <input matInput type="text" formControlName="applicantAttorneyFax" appPhoneFormatter
                      maxlength="14" />
                  </mat-form-field>
                </div>

                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Email</mat-label>
                    <input matInput type="email" formControlName="applicantAttorneyEmail" />
                    <mat-error *ngIf="form.get('applicantAttorneyEmail').hasError('email')">
                      Please enter a valid email address.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Assistant email</mat-label>
                    <input matInput type="email" formControlName="applicantAttorneyAssitantEmail" />
                    <mat-error *ngIf="form.get('applicantAttorneyAssitantEmail').hasError('email')">
                      Please enter a valid email address.
                    </mat-error>
                  </mat-form-field>
                </div>

              </div>
          <div *ngIf="form.get('unrepresented').value">
            <div
              fxLayout="row"
              fxLayoutAlign="start center"
              fxLayoutGap="24px"
              class="mt-10"
            >
              <h2 class="title m-0">Disability Evaluation Unit (DEU)</h2>
            </div>
            <div
              fxLayout="row"
              fxLayout.lt-md="column"
              fxLayoutGap="24px"
              fxLayoutGap.lt-md="0"
              class="mt-4"
            >
              <mat-form-field appearance="outline" fxFlex="auto">
                <mat-label>Address</mat-label>
                <input matInput formControlName="DeuAddress" />
              </mat-form-field>
            </div>

            <div
              fxLayout="row"
              fxLayout.lt-md="column"
              fxLayoutGap="24px"
              fxLayoutGap.lt-md="0"
            >
              <mat-form-field appearance="outline" fxFlex="auto">
                <mat-label>City</mat-label>
                <input
                  matInput
                  formControlName="DeuCity"
                  (input)="capitalizeFirstLetter('DeuCity')"
                  (paste)="capitalizeFirstLetter('DeuCity')"
                />
              </mat-form-field>

              <mat-form-field appearance="outline" fxFlex="auto">
                <mat-label>State</mat-label>
                <mat-select formControlName="DeuState">
                  <mat-option *ngFor="let state of states" [value]="state">{{
                    state
                  }}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" fxFlex="auto">
                <mat-label>Zip</mat-label>
                <input matInput formControlName="DeuZip" maxlength="9" />
              </mat-form-field>
            </div>
          </div>

              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0" class="mt-6">
                <h2 class="title m-0">Employer details</h2>
              </div>

              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0" class="mt-3">
                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>Employer</mat-label>
                  <input matInput formControlName="employer" (input)="capitalizeFirstLetter('employer')"
                    (paste)="capitalizeFirstLetter('employer')" />

                </mat-form-field>
              </div>

              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">


                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>Phone</mat-label>

                  <mat-select *ngIf="!employerPhoneInput" formControlName="employerPhone"
                    (selectionChange)="onEmployerPhoneSelectionChange($event.value)">
                    <mat-option [value]="'None Provided'">None Provided</mat-option>
                    <mat-option [value]="'Enter Phone'">Enter Phone</mat-option>
                  </mat-select>

                  <div *ngIf="employerPhoneInput" style="display: flex; align-items: center; gap: 4px; width: 100%;">
                    <input matInput type="text" formControlName="employerPhone" appPhoneFormatter maxlength="14"
                      placeholder="Enter Phone Number" style="flex: 1; min-width: 0;" />
                    <button mat-icon-button class="text-gray -mt-8 "
                      (click)="onEmployerPhoneSelectionChange('None Provided')" matTooltip="Reset to None Provided"
                      style="height: 20px; width: 20px; min-width: 20px; padding: 0;">
                      <mat-icon style="font-size: 18px;">close</mat-icon>
                    </button>
                  </div>

                  <mat-error *ngIf="form.get('employerPhone')?.hasError('invalidPhone')">
                    Invalid phone number format. Use (XXX) XXX-XXXX.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>Fax</mat-label>
                  <input matInput type="text" formControlName="employerFax" appPhoneFormatter maxlength="14" />
                  <mat-hint align="start" style="color: var(--app-accent); font-weight: 500">Optional</mat-hint>
                </mat-form-field>
              </div>

              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>Address line 1</mat-label>
                  <input matInput formControlName="employerAddress" />
                  <mat-error *ngIf="
                        form.get('employerAddress').hasError('required')
                      ">
                    Address is required.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>Address line 2</mat-label>
                  <input matInput formControlName="employerAddress_2" />
                </mat-form-field>
              </div>

              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>City</mat-label>
                  <input matInput formControlName="employerCity" (input)="capitalizeFirstLetter('employerCity')"
                    (paste)="capitalizeFirstLetter('employerCity')" />

                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>State</mat-label>
                  <mat-select formControlName="employerState">
                    <mat-option *ngFor="let state of states" [value]="state">{{
                      state
                      }}</mat-option>
                  </mat-select>

                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>Zip</mat-label>
                  <input matInput formControlName="employerZip" maxlength="9" />


                </mat-form-field>
              </div>

              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                <mat-form-field appearance="outline" fxFlex="auto">
                  <mat-label>Email</mat-label>
                  <input matInput type="email" formControlName="employerEmail" />
                  <mat-error *ngIf="form.get('employerEmail').hasError('email')">
                    Please enter a valid email address.
                  </mat-error>
                </mat-form-field>
              </div>


              <div *ngIf="form.get('sibtf')?.value !== true">
                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0" class="mt-6">
                  <h2 class="title m-0">Defense attorney details</h2>
                </div>

                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0" class="mt-3">
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Firm</mat-label>
                    <input matInput type="text" formControlName="defenseFirm"
                      (input)="capitalizeFirmName('defenseFirm')" (paste)="capitalizeFirmName('defenseFirm')" />

                  </mat-form-field>
                </div>

                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0" class="mt-3">
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>First name</mat-label>
                    <input matInput type="text" formControlName="defenseName"
                      (input)="capitalizeFirstLetter('defenseName')" (paste)="capitalizeFirstLetter('defenseName')" />

                  </mat-form-field>
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Middle name</mat-label>
                    <input matInput type="text" formControlName="defenseNamemiddle"
                      (input)="capitalizeFirstLetter('defenseNamemiddle')"
                      (paste)="capitalizeFirstLetter('defenseNamemiddle')" />
                  </mat-form-field>
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Last name</mat-label>
                    <input matInput type="text" formControlName="defenseNamelast"
                      (input)="capitalizeFirstLetter('defenseNamelast')"
                      (paste)="capitalizeFirstLetter('defenseNamelast')" />

                  </mat-form-field>
                </div>

                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Address line 1</mat-label>
                    <input matInput type="text" formControlName="defenseAddress" />

                  </mat-form-field>

                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Address line 2</mat-label>
                    <input matInput type="text" formControlName="defenseAddress_2" />

                  </mat-form-field>
                </div>

                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>City</mat-label>
                    <input matInput type="text" formControlName="defenseCity"
                      (input)="capitalizeFirstLetter('defenseCity')" (paste)="capitalizeFirstLetter('defenseCity')" />

                  </mat-form-field>

                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>State</mat-label>
                    <mat-select formControlName="defenseState">
                      <mat-option *ngFor="let state of states" [value]="state">{{
                        state
                        }}</mat-option>
                    </mat-select>

                  </mat-form-field>

                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Zip</mat-label>
                    <input matInput type="text" formControlName="defenseZip" maxlength="9" />

                  </mat-form-field>
                </div>

                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">

                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Phone</mat-label>

                    <ng-container *ngIf="!defenseAttorneyTelePhoneInput; else phoneInputTemplate_2">
                      <mat-select formControlName="defensePhone"
                        (selectionChange)="onDefenseSelectionChange($event.value)">
                        <mat-option [value]="'None Provided'">None Provided</mat-option>
                        <mat-option [value]="'Enter Phone'">Enter Phone</mat-option>
                      </mat-select>
                    </ng-container>

                    <ng-template #phoneInputTemplate_2>
                      <div style="display: flex; align-items: center; gap: 4px; width: 100%;">
                        <input matInput type="text" formControlName="defensePhone" appPhoneFormatter maxlength="14"
                          placeholder="Enter Phone Number" style="flex: 1; min-width: 0;" />

                        <button mat-icon-button class="text-gray -mt-8 "
                          (click)="onDefenseSelectionChange('None Provided')" matTooltip="Reset to None Provided"
                          style="height: 20px; width: 20px; min-width: 20px; padding: 0;">
                          <mat-icon style="font-size: 18px;">close</mat-icon>
                        </button>
                      </div>


                    </ng-template>

                    <mat-error *ngIf="form.get('defensePhone')?.hasError('invalidPhone')">
                      Invalid phone number format. Use (XXX) XXX-XXXX.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Fax</mat-label>
                    <input matInput type="text" formControlName="defenseFax" appPhoneFormatter maxlength="14" />
                    <mat-hint align="start" style="color: var(--app-accent); font-weight: 500">Optional</mat-hint>
                  </mat-form-field>
                </div>

                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Email</mat-label>
                    <input matInput type="email" formControlName="defenseEmail" />
                    <mat-error *ngIf="form.get('defenseEmail').hasError('email')">
                      Please enter a valid email address.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Assistant email</mat-label>
                    <input matInput type="email" formControlName="defenseAssistantEmail" />
                    <mat-error *ngIf="form.get('defenseAssistantEmail').hasError('email')">
                      Please enter a valid email address.
                    </mat-error>

                  </mat-form-field>
                </div>
              </div>
              <div *ngIf="form.get('sibtf')?.value !== true">
                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0" class="mt-6">
                  <h2 class="title m-0">Insurance company details</h2>
                </div>

                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0" class="mt-3">
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Insurance company</mat-label>
                    <input matInput type="text" formControlName="insuranceCompany"
                      (input)="capitalizeFirstLetter('insuranceCompany')"
                      (paste)="capitalizeFirstLetter('insuranceCompany')" />


                  </mat-form-field>
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Insurance company phone</mat-label>

                    <mat-select *ngIf="!insuranceCompanyPhoneInput" formControlName="insuranceCompanyPhone"
                      (selectionChange)="oninsuranceCompanyPhoneSelectionChange($event.value)">
                      <mat-option [value]="'None Provided'">None Provided</mat-option>
                      <mat-option [value]="'Enter Phone'">Enter Phone</mat-option>
                    </mat-select>

                    <div *ngIf="insuranceCompanyPhoneInput"
                      style="display: flex; align-items: center; gap: 4px; width: 100%;">
                      <input matInput type="text" formControlName="insuranceCompanyPhone" appPhoneFormatter
                        maxlength="14" placeholder="Enter Phone Number" style="flex: 1; min-width: 0;" />
                      <button mat-icon-button class="text-gray -mt-8 "
                        (click)="oninsuranceCompanyPhoneSelectionChange('None Provided')"
                        matTooltip="Reset to None Provided"
                        style="height: 20px; width: 20px; min-width: 20px; padding: 0;">
                        <mat-icon style="font-size: 18px;">close</mat-icon>
                      </button>
                    </div>

                    <mat-error *ngIf="form.get('insuranceCompanyPhone')?.hasError('invalidPhone')">
                      Invalid phone number format. Use (XXX) XXX-XXXX.
                    </mat-error>
                  </mat-form-field>
                </div>

                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Payer ID</mat-label>
                    <input matInput type="text" formControlName="payerId" />
                  </mat-form-field>
                </div>

                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Adjuster first name</mat-label>
                    <input matInput type="text" formControlName="adjuster" (input)="capitalizeFirstLetter('adjuster')"
                      (paste)="capitalizeFirstLetter('adjuster')" />

                  </mat-form-field>
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Adjuster middle name</mat-label>
                    <input matInput type="text" formControlName="adjuster_middleName"
                      (input)="capitalizeFirstLetter('adjuster_middleName')"
                      (paste)="capitalizeFirstLetter('adjuster_middleName')" />

                  </mat-form-field>
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Adjuster last name</mat-label>
                    <input matInput type="text" formControlName="adjuster_lastName"
                      (input)="capitalizeFirstLetter('adjuster_lastName')"
                      (paste)="capitalizeFirstLetter('adjuster_lastName')" />

                  </mat-form-field>
                </div>

                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Address line 1</mat-label>
                    <input matInput type="text" formControlName="insuranceAddress" />

                  </mat-form-field>

                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Address line 2</mat-label>
                    <input matInput type="text" formControlName="insuranceAddress_2" />

                  </mat-form-field>
                </div>

                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>City</mat-label>
                    <input matInput type="text" formControlName="insuranceCity"
                      (input)="capitalizeFirstLetter('insuranceCity')"
                      (paste)="capitalizeFirstLetter('insuranceCity')" />

                  </mat-form-field>

                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>State</mat-label>
                    <mat-select formControlName="insuranceState">
                      <mat-option *ngFor="let state of states" [value]="state">{{
                        state
                        }}</mat-option>
                    </mat-select>

                  </mat-form-field>

                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Zip</mat-label>
                    <input matInput type="text" formControlName="insuranceZip" maxlength="9" />

                  </mat-form-field>
                </div>

                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Adjuster phone</mat-label>

                    <ng-container *ngIf="!insurancePhoneInput; else insurancePhoneInput_1">
                      <mat-select formControlName="insurancePhone"
                        (selectionChange)="onInsurancePhoneSelectionChange($event.value)">
                        <mat-option [value]="'None Provided'">None Provided</mat-option>
                        <mat-option [value]="'Enter Phone'">Enter Phone</mat-option>
                      </mat-select>
                    </ng-container>

                    <ng-template #insurancePhoneInput_1>
                      <div style="display: flex; align-items: center; gap: 4px; width: 100%;">
                        <input matInput type="text" formControlName="insurancePhone" appPhoneFormatter maxlength="14"
                          placeholder="Enter Phone Number" style="flex: 1; min-width: 0;" />

                        <button mat-icon-button class="text-gray -mt-8 "
                          (click)="onInsurancePhoneSelectionChange('None Provided')" matTooltip="Reset to None Provided"
                          style="height: 20px; width: 20px; min-width: 20px; padding: 0;">
                          <mat-icon style="font-size: 18px;">close</mat-icon>
                        </button>
                      </div>


                    </ng-template>


                    <mat-error *ngIf="form.get('insurancePhone')?.hasError('invalidPhone')">
                      Invalid phone number format. Use (XXX) XXX-XXXX.
                    </mat-error>
                  </mat-form-field>


                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Adjuster fax</mat-label>
                    <input matInput type="text" formControlName="insuranceFax" appPhoneFormatter maxlength="14" />
                  </mat-form-field>
                </div>

                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Adjuster email</mat-label>
                    <input matInput type="text" formControlName="insuranceEmail" />
                    <mat-error *ngIf="form.get('insuranceEmail').hasError('email')">
                      Please enter a valid email address.
                    </mat-error>

                  </mat-form-field>

                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Adjuster assistant email</mat-label>
                    <input matInput type="text" formControlName="insuranceAssistant" />
                    <mat-error *ngIf="form.get('insuranceAssistant').hasError('email')">
                      Please enter a valid email address.
                    </mat-error>

                  </mat-form-field>
                </div>

                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0" class="mt-3">
                  <div formArrayName="insuranceClaimNo">
                    <div *ngFor="
                        let claimControl of insuranceClaimNoArray.controls;
                        let i = index
                      ">
                      <mat-form-field appearance="outline" fxFlex="auto">
                        <mat-label>Insurance claim No {{ i + 1 }}</mat-label>
                        <input matInput type="text" [formControlName]="i" />

                      </mat-form-field>
                      <button mat-icon-button class="qqmeIcon-2" type="button" (click)="removeClaimNumber(i)"
                        *ngIf="insuranceClaimNoArray.length > 1">
                        <mat-icon>remove_circle</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>

                <button mat-button class="qqmeIcon-2" matTooltip="Add Claim Number" type="button"
                  (click)="addClaimNumber()">
                  + Add Claim Number
                </button>
              </div>
              <div *ngIf="form.get('sibtf')?.value === true">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px" class="mt-10">
                  <h2 class="title m-0 heading-c">
                    Subsequent Injuries Benefits Trust Fund details
                  </h2>
                </div>

                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0" class="mt-6">
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Subsequent injuries benefits trust fund</mat-label>
                    <input matInput type="text" formControlName="subFund" (input)="capitalizeFirstLetter('subFund')"
                      (paste)="capitalizeFirstLetter('subFund')" />

                  </mat-form-field>
                </div>

                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Phone</mat-label>
                    <input matInput type="text" formControlName="subPhone" appPhoneFormatter />
                  </mat-form-field>

                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Fax</mat-label>
                    <input matInput type="text" formControlName="subFax" appPhoneFormatter />
                  </mat-form-field>
                </div>

                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Address line 1</mat-label>
                    <input matInput type="text" formControlName="subAddress" />

                  </mat-form-field>
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Address line 2</mat-label>
                    <input matInput type="text" formControlName="subAddress_2" />
                  </mat-form-field>
                </div>

                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>City</mat-label>
                    <input matInput type="text" formControlName="subCity" (input)="capitalizeFirstLetter('subCity')"
                      (paste)="capitalizeFirstLetter('subCity')" />


                  </mat-form-field>

                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>State</mat-label>
                    <mat-select formControlName="subState">
                      <mat-option *ngFor="let state of states" [value]="state">{{
                        state
                        }}</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Zip</mat-label>
                    <input matInput type="text" formControlName="subZip" maxlength="9" />

                  </mat-form-field>
                </div>

                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutGap.lt-md="0">
                  <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Email</mat-label>
                    <input matInput type="text" formControlName="subEmail" />
                  </mat-form-field>
                </div>
              </div>
            </form>
          </div>
        </div>

      </div>
      <div class="w-full p-6 flex justify-between items-center bg-white shadow-md sticky bottom-0"
        style="background-color: #D0D8E8">
        <span class="text-lg flex items-center">
          <!-- <mat-icon class="t2 px-2">phone</mat-icon> 213.947.0000 -->
        </span>

        <button mat-raised-button class="save-draft" type="button" (click)="onSave()" matTooltip="Submit"
          [disabled]="isSubmitting">
          <span *ngIf="!isSubmitting">Submit</span>
          <span *ngIf="isSubmitting">
            <mat-spinner diameter="20"></mat-spinner> Submitting...
          </span>
        </button>
      </div>

    </div>

  </mat-sidenav-content>

</mat-sidenav-container>